import type { HTMLAttributes } from "react";
import { tv } from "tailwind-variants";

import { useFormField } from "./use-form-field";

export function FormMessage({
  ref,
  className,
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { ref?: React.RefObject<HTMLParagraphElement | null> }) {
  const { error, formMessageId, isDirty } = useFormField();
  const body = error ? String(error.message) : children;

  if (body === undefined || !isDirty) {
    return null;
  }

  return (
    <p
      ref={ref}
      id={formMessageId}
      className={tv({ base: "pl-1 font-semibold text-destructive text-xs" })({ className })}
      {...props}
    >
      {body}
    </p>
  );
}
FormMessage.displayName = "FormMessage";
